module.exports = __webpack_public_path__ + "img/bg_01.142a4dc6.png";